import { Link } from "react-router-dom";
import styles from "./Breadcrumbs.module.css";

export default function Breadcrumbs({ title }) {
  return (
    <nav className={styles.container}>
      <Link to="/" className={styles.home}>Home</Link>
      <span className={styles.separator}>›</span>
      <span className={styles.current} title={title}>{title}</span>
    </nav>
  );
}
